module.exports = __webpack_public_path__ + "img/1.faaaa1e0.png";